import {HTMLAttributes} from 'react';

export function DialogViewerSetting({
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div {...props}>{children}</div>;
}

export const DialogViewerSettingType = (<DialogViewerSetting />).type;
